import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserService } from "../../services/user.service";
import { addUserAct, addSuccessUserAct, 
    setViolationsUserAct, updateUserAct, updateSuccessUserAct, showMsgErrorAct, 
    findUserAct, loadUserByIdAct,
    findAllRolesAct,
    loadAllRolesAct} from "./users.actions";
import { EMPTY, catchError, exhaustMap, map, of, tap } from "rxjs";
import { User } from "../../models/user";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class UsersEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private userService = inject(UserService);
    private alerta = inject(AlertaService);

    /*loadUsersEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(loadUserAct),
            exhaustMap(action => this.userService.findAllPageableUser(action.page, action.pageSize)
                .pipe(
                    map(pageable => {
                        const users = pageable.list as User[];
                        delete pageable.list;
                        const paginator = pageable;

                        return findAllPageableUserAct({ users, paginator });
                    }),
                    catchError((error) => of(error))
                )
            )
        )
    );*/

    findUserEffect$ = createEffect(
            () => this.actions$.pipe(
                ofType(findUserAct),
                exhaustMap(action => this.userService.findUserById(action.id)
            .pipe(
                map(user => loadUserByIdAct({ user })),
                catchError(error => of(error))
            ))
            )
        );

    addUserEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(addUserAct),
            exhaustMap(action => this.userService.createUser(action.userNew)
                .pipe(
                    map(userNew => addSuccessUserAct({ userNew })),
                    //catchError(error => (error.status == 400) ? of(setViolationsUserAct({ userForm: action.userNew, violations: this.violationsToObject(error.error.violations) })) : of(showMsgErrorAct({ error }))
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsUserAct({ userForm: action.userNew, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                         }else {
                            return of(showMsgErrorAct({ error }));
                         }
                    }
                    )
                )
            )
        )
    );

    updateUserEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateUserAct),
            exhaustMap(action => this.userService.updateUser(action.userUpdated)
                .pipe(
                    map(userUpdated => updateSuccessUserAct({ userUpdated })),
                    catchError(error => (error.status == 400) ? of(setViolationsUserAct({ userForm: action.userUpdated, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    /*catchError((error) => {
                        if(error.status == 400){
                            return setViolationsUserAct({ userForm: action.userUpdated, violations: this.violationsToObject(error.parameterViolations.violations) });
                        }else{
                            return of(showMsgErrorAct({ error }));
                        }

                    })*/
                    )
                )
            )
        )
    );

    /*removeUserEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(removeUserAct),
            exhaustMap(action => this.userService.removeUser(action.id)
                .pipe(
                    map(() => removeSuccessUserAct({ id: action.id }))
                )
            )
        )
    );*/

    addSuccessUserEffect$ = createEffect(() => this.actions$.pipe(
        ofType(addSuccessUserAct),
        tap(() => {
            this.router.navigate(['/users']);

            /*Swal.fire({
                title: "Creado nuevo usuario!",
                text: "Usuario creado con exito!",
                icon: "success"
            });*/
            this.alerta.correct('Usuario creado con exito!', () => {
                window.location.reload();
            });
        })
    ), { dispatch: false });
    
    updateSuccessUserEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessUserAct),
        tap(() => {
            this.router.navigate(['/users']);

            /*Swal.fire({
                title: "Actualizado!",
                text: "Usuario editado con exito!",
                icon: "success"
            });*/
            this.alerta.error("Se ha precentado un error interno");
        })
    ), {dispatch: false});

    /*removeSuccessUserEffect$ = createEffect(() => this.actions$.pipe(
        ofType(removeSuccessUserAct),
        tap(() => {
            this.router.navigate(['/users']);

            Swal.fire({
                title: "Eliminado!",
                text: "Usuario eliminado con exito.",
                icon: "success"
            });
        })
    ), { dispatch: false });*/

    findAllRolesEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findAllRolesAct),
            exhaustMap(action => this.userService.findAllRoles()
        .pipe(
            map(roles => loadAllRolesAct({ roles })),
            catchError(error => of(error))
        ))
        )
    );

    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        //exhaustMap(action
        tap((action) => {
            //this.router.navigate(['/users']);

            /*Swal.fire({
                title: "Error",
                text: "Se ha precentado un error interno: " + action.error.message,
                icon: "error",
                //footer: action.error.message//  '<a href="#">Why do I have this issue?</a>'
            });*/
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });

    /*violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { field: string; message: any; }) => {
            obj[item.field.slice(item.field.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };*/
    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            //obj[item.field.slice(item.field.lastIndexOf('.') + 1)] = item.message;
            //obj[item.field.slice(item.field.indexOf('.') + 1).replaceAll('.', '_')] = item.message;
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
}